(function () {
    'use strict';

    angular.module('swif.fluid')

        .factory('swifFluidStatisticsService', swifFluidStatisticsService)

        .config(
            function($routeProvider) {
                $routeProvider.when('/fluid/consumption/statistics_view', {
                    templateUrl: 'partials/fluid/consumption_statistics_view.html',
                    controller: 'FluidConsumptionsChartController',
                    reloadOnSearch: false,
                    resolve: {
                        d3: function (swifFluidStatisticsService) {
                            return swifFluidStatisticsService.resolveD3();
                        },
                        fluidsCategoriesCollection:  function (swifFluidStatisticsService) {
                            return swifFluidStatisticsService.resolveFluidsCategoriesCollection();
                        },
                        fluidsStatisticCategoriesCollection:  function (swifFluidStatisticsService) {
                            return swifFluidStatisticsService.resolveFluidsStatisticCategoriesCollection();
                        }
                    }
                });
            }
        )

        .component('fluidGraph', {
            templateUrl: 'partials/fluid/fluid_graph.html',
            controller: FluidGraphController,
            bindings: {
                sites: '<',
                equipmentCateg: '<',
                periods: '<',
                yearColors: '<',
                statisticCategories: '<',
                fluidType: '@'
            }
        })

        .controller('FluidConsumptionsChartController',
            function ($scope, swif, swifStatisticsService, fluidsCategoriesCollection, fluidsStatisticCategoriesCollection) {
                console.log('init FluidConsumptionChartController');
                swif.settings.page.title = 'Statistics';
                // Initialize filters
                $scope.selectFilters = {
                    equipment_categ_fluid: {}
                };
                $scope.contentType = 'fluids_consumption';
                $scope.years = swifStatisticsService.getYears($scope.contentType);
                $scope.yearButtons = swifStatisticsService.getYearsButtons($scope.contentType);
                $scope.searchFilter = {
                    site_ids:[],
                    periodType: 'manual',
                    start_period: swifStatisticsService.getDefaultStartPeriod(),
                    end_period: swifStatisticsService.getDefaultEndPeriod(),
                    periods: [],
                    equipment_categ: {}
                };

                // Add equipment category filter (is_fluid_meter)
                swif.data.addFilter($scope.selectFilters.equipment_categ_fluid, 'is_fluid_meter', '=', true);

                fluidsCategoriesCollection.getItems().then(function (result) {
                    $scope.fluidsCategories = result;
                });

                fluidsStatisticCategoriesCollection.getItems().then(function (result) {
                    $scope.statisticCategories = [{"name": "Coût", "id": 0}].concat(result);
                });

                $scope.onClickYear = function (event) {
                    var button = event.target;
                    if (button.id && button.className){
                        //we update the buttons style
                        var yearToRemove = button.id;
                        if (_.contains(_.words(button.className), "active")){
                            button.className = "btn btnYear";
                            for (let i=$scope.searchFilter.periods.length-1; i>=0; i--) {
                                if ($scope.searchFilter.periods[i].start_period.search(yearToRemove)>=0) {
                                    $scope.searchFilter.periods.splice(i, 1);
                                };
                            }
                        }else{
                            button.className = "btn btnYear active";
                            addYearToChart(yearToRemove);
                        }
                    }
                };

                $scope.onEquipmentCategory = function (equipmentCategory) {
                    if (equipmentCategory && equipmentCategory.id){
                        $scope.searchFilter.equipment_categ = equipmentCategory.id;
                    }
                };

                function addYearToChart (yearToAdd) {
                    //remove 4 characters at the begining of the string (witch represent the reference year)
                    var startPeriodDate = $scope.searchFilter.start_period.substring(4, $scope.searchFilter.start_period.length);
                    //add the new year at the beginning
                    startPeriodDate = yearToAdd + startPeriodDate;
                    var endPeriodDate = $scope.searchFilter.end_period.substring(4, $scope.searchFilter.end_period.length);
                    endPeriodDate = yearToAdd + endPeriodDate;

                    $scope.searchFilter.periods.push({start_period:startPeriodDate, end_period:endPeriodDate});
                };

                function resetCharts() {
                    $scope.searchFilter.periods = [];
                    resetYearsButtons();
                };

                function resetYearsButtons() {
                    if ($scope.yearButtons) {
                        for (let i = 0; i < $scope.yearButtons.length; i++) {
                            var id = $scope.yearButtons[i].id;
                            var btn = angular.element('#' + id);
                            if (btn[0]) {
                                btn[0].className = "btn btnYear";
                            }
                        }
                    }
                };

                $scope.$watchGroup(['searchFilter.start_period', 'searchFilter.end_period'],
                    function (newV, oldV) {
                        if(!_.contains(newV, undefined) && !_.contains(newV, false)) {
                            resetCharts();
                            $scope.searchFilter.periods.push({start_period:$scope.searchFilter.start_period,
                                end_period:$scope.searchFilter.end_period});
                        }
                    });

                $scope.$watch('searchFilter.periodType',
                    function watchSearchFilterPeriodType (newV, oldV) {
                        if(newV && !angular.equals(newV, oldV)) {
                            if(newV !== 'manual') {
                                $scope.searchFilter.start_period = newV + '-01-01';
                                $scope.searchFilter.end_period = newV + '-12-31';
                            }
                        }
                    });

                $scope.$watch('displaySecondPeriod',
                    function watchDisplaySecondPeriod (newV, oldV) {
                        if(!angular.equals(newV, oldV)) {
                            if((newV===false) && (oldV===true)) {
                                resetCharts();
                                $scope.searchFilter.periods.push({start_period:$scope.searchFilter.start_period,
                                    end_period:$scope.searchFilter.end_period});
                            }
                        }
                    });
            }
        );

    function FluidGraphController($scope, swif, swifMomentUtility) {
        var $ctrl = this;

        $ctrl.$onInit = function () {
            $ctrl.outputFormat = 'MM-YYYY';
            $ctrl.dateTooltipFormat = 'MMMM YYYY';
            $ctrl.defaultStatisticsCategoryIndex = 0;
            $ctrl.meterIds = {};
            $ctrl.fluidChartData = [];
            $ctrl.fluidChartYunit = '';
            $ctrl.fluidBarPlusLineChartData = [];
            $ctrl.fluidChartY1unit = '';
            $ctrl.fluidChartY2unit = '';
            $ctrl.statisticCategory = [];
            $ctrl.scale = 'month';
        };

        var multiBarChart = nv.models.multiBarChart()
            .margin({top: 30, right: 60, bottom: 50, left: 70})
            .x(function(d,i) { return i })
            .showLegend(false)
            .y(function(d) { return d[1] })
            .color(function(d){
                return d.data ? d.data.color : false;
            });

        //don't display the grouped/stacked buttons
        multiBarChart.showControls(false);

        multiBarChart.yAxis
            .tickFormat(function(d) {
                return d3.format(',f')(d) + ' ' + $ctrl.fluidChartYunit;
            });

        multiBarChart.xAxis
            .showMaxMin(false)
            .tickFormat(function(d) {
                if ($ctrl.fluidChartData[0]){
                    var dx = $ctrl.fluidChartData[0].values[d] && $ctrl.fluidChartData[0].values[d][0] || 0;
                    return formatXaxisDate(dx);
                }
            });

        multiBarChart.tooltip.contentGenerator(function (e) {
            if (!_.isUndefined(e.data)){
                let date = '';
                if ($ctrl.scale==='year'){
                    date = e.data[0];
                }else{
                    date = swifMomentUtility.formatDate(e.data[0], $ctrl.dateTooltipFormat);
                }
                return '<p>' +  e.data[1] + ' ' + $ctrl.fluidChartYunit + ' en ' + date + '</p>'
            }
        });


        var barPlusLineChart = nv.models.linePlusBarChart()
            .margin({top: 30, right: 60, bottom: 50, left: 70})
            //We can set x data accessor to use index. Reason? So the bars all appear evenly spaced.
            .x(function(d,i) { return i })
            .showLegend(false)
            .focusEnable(false)
            .y(function(d,i) {return d[1] })
            .color(function(d){return d.data ? d.data.color : false});

        function formatXaxisDate(date) {
            var dateFormat = 'MMM';
            if ($ctrl.scale==='year'){
                dateFormat = 'YYYY';
            }
            return swifMomentUtility.formatDate(new Date(date), dateFormat);
        }

        barPlusLineChart.xAxis
            .tickFormat(function(d) {
                if ($ctrl.fluidBarPlusLineChartData[0]){
                    var dx = $ctrl.fluidBarPlusLineChartData[0].values[d] && $ctrl.fluidBarPlusLineChartData[0].values[d][0] || 0;
                    return formatXaxisDate(dx);
                }
            });

        barPlusLineChart.y1Axis
            .tickFormat(function(d) {
                return d3.format(',f')(d) + ' ' + $ctrl.fluidChartY1unit;
            });

        barPlusLineChart.y2Axis
            .tickFormat(function(d) {
                return d3.format(',f')(d) + ' ' + $ctrl.fluidChartY2unit;
            });

        barPlusLineChart.tooltip.contentGenerator(function (e) {
            if (!_.isUndefined(e.data) || !_.isUndefined(e.point)){
                let eDataPoint = [];
                let unit = '';
                let date = '';
                if (e.point) {
                    eDataPoint = e.point;
                    unit = $ctrl.fluidChartY2unit;
                }else {
                    eDataPoint = e.data;
                    unit = $ctrl.fluidChartY1unit;
                }
                if ($ctrl.scale==='year'){
                    date = eDataPoint[0];
                }else{
                    date = swifMomentUtility.formatDate(eDataPoint[0], $ctrl.dateTooltipFormat);
                }
                return '<p>' +  eDataPoint[1] + ' ' + unit + ' en ' + date + '</p>';
            }
        });

        function getDataKey(startPeriod, endPeriod, unit){
            return swifMomentUtility.formatDate(startPeriod, $ctrl.outputFormat) + ' - ' +
                swifMomentUtility.formatDate(endPeriod, $ctrl.outputFormat) + ' / ' + unit;
        };

        function getColorByYear(period) {
            if ($ctrl.yearColors) {
                for (let i = 0; i < $ctrl.yearColors.length; i++) {
                    if (period.substring(0,4).search($ctrl.yearColors[i].id)>=0){
                        return $ctrl.yearColors[i].color
                    }
                }
            }
        };

        function addYearBarsToChart(startPeriod, endPeriod) {
            swif.data.callKw(
                'fluids_consumption',
                'get_consumptions_summary',
                [Number($ctrl.fluidType), $ctrl.meterIds, $ctrl.equipmentCateg, null, startPeriod, endPeriod, $ctrl.scale],
                {context: swif.user.getAuthenticatedUser().context}
            ).then(function (data) {
                $ctrl.fluidChartData.push({
                    key: getDataKey(startPeriod, endPeriod, data[0].unit),
                    values: data[0].data,
                    color: getColorByYear(startPeriod)
                });
                updateChart();
                return true;
            });
        };

        function addBarsToChart(statisticsCategoryIndex, startPeriod, endPeriod) {
            if ($ctrl.equipmentCateg){
                swif.data.callKw(
                    'fluids_consumption',
                    'get_consumptions_summary',
                    [Number($ctrl.fluidType), $ctrl.meterIds, $ctrl.equipmentCateg, statisticsCategoryIndex, startPeriod, endPeriod, $ctrl.scale],
                    {context: swif.user.getAuthenticatedUser().context}
                ).then(function (data) {
                    $ctrl.fluidChartYunit = data[0].unit;
                    $ctrl.fluidChartData.push({
                        key: getDataKey(startPeriod, endPeriod, data[0].unit),
                        values: data[0].data,
                        color: getColorByYear(startPeriod)
                    });

                    $ctrl.fluidChartY1unit = data[0].unit;
                    $ctrl.fluidBarPlusLineChartData.push({
                        key: getDataKey(startPeriod, endPeriod, data[0].unit),
                        bar: true,
                        values: data[0].data,
                        color: getColorByYear(startPeriod)
                    });
                    $ctrl.fluidChartY2unit = data[1].unit;
                    $ctrl.fluidBarPlusLineChartData.push({
                        key: getDataKey(startPeriod, endPeriod, data[1].unit),
                        values: data[1].data,
                        color: "#000"
                    });
                    updateChart();
                    return true;
                });
            }
        };

        function changeLineChart (statisticsCategoryIndex) {
            $ctrl.fluidBarPlusLineChartData = [];

            swif.data.callKw(
                'fluids_consumption',
                'get_consumptions_summary',
                [Number($ctrl.fluidType), $ctrl.meterIds, $ctrl.equipmentCateg, statisticsCategoryIndex, $ctrl.periods[0].start_period, $ctrl.periods[0].end_period, $ctrl.scale],
                {context: swif.user.getAuthenticatedUser().context}
            ).then(function (data) {

                $ctrl.fluidBarPlusLineChartData.push({
                    key: getDataKey($ctrl.periods[0].start_period, $ctrl.periods[0].end_period, data[0].unit),
                    bar: true,
                    values: data[0].data,
                    color: getColorByYear($ctrl.periods[0].start_period)
                });
                $ctrl.fluidChartY2unit = data[1].unit;
                $ctrl.fluidBarPlusLineChartData.push({
                    key: getDataKey($ctrl.periods[0].start_period, $ctrl.periods[0].end_period, data[1].unit),
                    values: data[1].data,
                    color: "#000"
                });
                updateChart();
                return true;
            });
        };

        function updateChart(){
            //to make the graph width responsive
            multiBarChart.width(window.innerWidth);
            var graphId = '#fluidMultiBarChart' + $ctrl.fluidType + ' svg';
            d3.select(graphId)
                .datum($ctrl.fluidChartData)
                .transition().duration(500)
                .call(multiBarChart);

            //to make the graph width responsive
            // 65px is to well display units on the right
            barPlusLineChart.width(window.innerWidth-75);
            var graphId = '#fluidLinePlusBarChart' + $ctrl.fluidType + ' svg';
            d3.select(graphId)
                .datum($ctrl.fluidBarPlusLineChartData)
                .transition().duration(500)
                .call(barPlusLineChart);
        };

        function initChartsData() {
            $ctrl.fluidChartData = [];
            $ctrl.fluidBarPlusLineChartData = [];
            let statisticsCategoryIndex = $ctrl.defaultStatisticsCategoryIndex;
            if ($ctrl.statisticCategory[0]){
                statisticsCategoryIndex = $ctrl.statisticCategory[0];
            }
            addBarsToChart(statisticsCategoryIndex, $ctrl.periods[0].start_period, $ctrl.periods[0].end_period);
        };

        function removeYearToChart (period, chartData) {
            // Be careful, we take the year off the period to search it in the key
            var yearToRemove = period.substring(0,4);
            //remove from chartData the datas by comparing the key with the year
            for (var i=chartData.length-1; i>=0; i--) {
                if (chartData[i].key.search(yearToRemove)>=0) {
                    chartData.splice(i, 1);
                };
            }
            updateChart();
        };

        function updateMeters() {
            var metersFilter = {domain : []};
            if ($ctrl.sites){
                metersFilter.domain.push(['site_id', 'in', $ctrl.sites]);
            }
            metersFilter.domain.push(['category_id', '=', Number($ctrl.fluidType)]);
            metersFilter.domain.push(['categ_id', 'child_of', Number($ctrl.equipmentCateg)]);
            metersFilter.fields = ['id'];
            swif.data.searchRead('fluids_meter', metersFilter).then(function (data) {
                $ctrl.meterIds = data.ids;
            });
        }

        $scope.$watchCollection('$ctrl.periods',
            function (newV, oldV) {
                if (newV && oldV) {
                    if (newV.length > 0 && oldV.length >= 0) {
                        if (newV.length === oldV.length) {
                            if ((newV[0].start_period != oldV[0].start_period) || (newV[0].end_period != oldV[0].end_period)) {
                                // user change the current period
                                initChartsData();
                            }
                        } else {
                            if (newV.length > oldV.length) {
                                // we have a new period to add in charts
                                var periodToAdd = newV[newV.length - 1];
                                addYearBarsToChart(periodToAdd.start_period, periodToAdd.end_period);
                            } else if (newV.length < oldV.length) {
                                // we have a period to remove from charts
                                var periodeToRemove = _.difference(oldV, newV);
                                if (periodeToRemove.length === $ctrl.fluidChartData.length) {
                                    //we did a reset
                                    initChartsData();
                                } else {
                                    //we remove just one year
                                    removeYearToChart(periodeToRemove[0].start_period, $ctrl.fluidChartData);
                                }
                            }
                        }
                    }
                }
            });

        $scope.$watch('$ctrl.sites',
            function (newV, oldV) {
                if(!_.contains(newV, undefined)
                    && !_.contains(newV, false)
                    && !_.isEmpty(newV)) {
                    updateMeters();
                }
            });

        $scope.$watch('$ctrl.meterIds',
            function (newV, oldV) {
                if (newV && oldV) {
                    if (!_.isEmpty(newV) || !_.isEmpty(oldV)) {
                        initChartsData();
                    }
                }else if (!_.isEmpty(oldV)){
                    //user have delete the last meter and swif-widget-select-multiple return undefined...
                    initChartsData();
                }
            });

        $scope.$watch('$ctrl.statisticCategory',
            function (newV, oldV) {
                if (newV && oldV) {
                    if (newV.length>0){
                        changeLineChart(newV[0]);
                    }
                }
            });

        $scope.$watch('$ctrl.scale',
            function (newV, oldV) {
                if (newV && oldV) {
                    if (newV != oldV){
                        initChartsData();
                    }
                }
            });

        $scope.$watch('$ctrl.equipmentCateg',
            function (newV, oldV) {
                if (newV != oldV){
                    if (newV && !oldV){
                        // INITIALISATION for all meters
                        initChartsData();
                    }else{
                        updateMeters();
                    }
                }
            });
    };


    function swifFluidStatisticsService(swif) {
        var service = {};
        service.resolveD3 = function () {
            return swif.route.check({resources: ['d3']});
        };

        // Be careful, resolve will wait for the collection, but it may not be full with items...
        service.resolveFluidsCategoriesCollection = function () {
            return swif.collections.createOrUpdate(
                'fluids_categories',
                'fluids_category',
                {}
            );
        };
        service.resolveFluidsStatisticCategoriesCollection = function () {
            return swif.collections.createOrUpdate(
                'fluids_statistic_categories',
                'fluids_statistic_category',
                {}
            );
        };
        return service;
    }
})();
